import { render, staticRenderFns } from "./editDetail.vue?vue&type=template&id=4f89a7f4&scoped=true&"
import script from "./editDetail.vue?vue&type=script&lang=js&"
export * from "./editDetail.vue?vue&type=script&lang=js&"
import style0 from "./editDetail.vue?vue&type=style&index=0&id=4f89a7f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f89a7f4",
  null
  
)

export default component.exports